import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(public http: HttpClient) { }

  getCardInfo() {
    return this.http.get(`http://localhost:3000/check-cardreader`).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }


  login() {
    return this.http.get(`${environment.API_ENDPOINT}business/info`).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }


  idCardTransaction(params) {
    return this.http.post(`${environment.API_ENDPOINT}payments/card`, params).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }


  barqTransaction(params) {
    return this.http.post(`${environment.API_ENDPOINT}payments/barq`, params).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  getTransactions(params) {
    return this.http.get(`${environment.API_ENDPOINT}payments/transactions`, {params: params}).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  createWayyak(params){
    return this.http.post(`${environment.API_ENDPOINT}payments/wayyak`, params).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  getWayyakPendingRequest(params){
    return this.http.get(`${environment.API_ENDPOINT}payments/wayyak`, { params: params }).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }


  updateFcmToken(token){
    let params = {
        "fcmToken": token
    }
    return this.http.patch(`${environment.API_ENDPOINT}settings/token`, params).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  generatePaymentLink(params){
    return this.http.post(`${environment.API_ENDPOINT}Paymentlink`, params).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  viewAllPaymentLink(params){
    return this.http.get(`${environment.API_ENDPOINT}Paymentlink`, { params: params }).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  getProductsLookups() {
    return this.http.get(`${environment.API_ENDPOINT}Paymentlink/productlookups`).pipe(
        map(data => data),
        catchError(error => { throw error; }));
  }

  getSettings(){
    return this.http.get(`${environment.API_ENDPOINT}settings`).pipe(
        map(data => data),
        catchError(error => { throw error; }));
  }


  checkEv12Enabled(){
    return this.http.get(`${environment.API_ENDPOINT}Paymentlink/checkout`).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }

  getRedeemptions(params){
    return this.http.get(`${environment.API_ENDPOINT}coupon/redemptions`, { params: params }).pipe(
      map(data => data),
      catchError(error => { throw error; }));
  }


  updateWayyakStatus(Id){
    let params = {
      "Id": Id,
    }
    return this.http.put(`${environment.API_ENDPOINT}payments/wayyak/cancel`, params).pipe(
        map(data => data),
        catchError(error => { throw error; }));
  }


}




// Future<ApiResponseModel> getRedemptionList(
//   {int? limit = 20,
//   int? pageNumber = 1,
//   String? startDate,
//   String? endDate,
//   String? search}) async {
// final Map<String, dynamic> params = <String, dynamic>{
//   'limit': limit,
//   'skip': pageNumber,
// };

// if (startDate != null) {
//   params['startDate'] = startDate;
// }
// if (endDate != null) {
//   params['endDate'] = endDate;
// }
// if (search != null) {
//   params['search'] = search;
// }

// try {
//   final Response<dynamic> res = await httpClient
//       .get<dynamic>('', queryParameters: params);

//   return ApiResponseModel(
//     success: res.data['success'] as bool,
//     code: res.data['code'] as int,
//     message: res.data['description'] as String,
//     data: res.data['data'],
//   );
// } on DioError catch (e) {
//   return ApiResponseModel(
//     success: e.response?.data?['success'] as bool,
//     code: e.response?.data?['code'] as int,
//     message: e.response?.data?['description'] as String,
//   );
// } catch (e) {
//   return ApiResponseModel(success: false, code: 500, message: e.toString());
// }
// }



